import * as React from 'react';
import {getReactButton, getReactTableLocal} from "../../index";
import {RefObject} from "react";
import {ReactTableState} from "./ReactTable";

interface ReactSearchAsYouTypeData {
    id?: string,
    label?: string,
    style?: {},
    css?: string,
    labelStyle?: {},
    labelCSS?: (selectedRecordIndex: number) => string,
    textStyle?: {},
    textCSS?: "",
    headers?: any[],
    headersCSS?: string,
    rowsCSS?: (row: any, rowIndex: number) => string,
    rowsStyle?: (row: any, rowIndex: number) => {},
    rows?: any[],
    tabIndex? : null,
    divTableContainerCSS?: string,
    highlightSelectedRow?: number, // -1 to turn off
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string,
    rowHasFocusCSS?: (row: any, rowIndex: number) => string,
    selectRecordWithRowClick?: boolean,
    toolBarDisplayHeader?: boolean,
    toolBarDisplayFooter?: boolean,
    toolBarNumToDisplay?: number,
    selectColumns?: [],
    saytSelectDisplayColumn?: number,
    onSAYTClickEvent?: (row: any, storedData?: any) => {},
    hideSearchOnSelect?: boolean,
    tableStyle?: {},
    showClearButton?: boolean,
    clearButtonTabIndex?: null,
    showSearchButton?: boolean,
    showSearchButtonAfterClearButton?: boolean,
    searchButtonTabIndex?: null,
    disabled?: boolean,
    disableHeaderScrolling?: boolean,
    disableID?: string,
    refreshID?: string,
    toolBarRefreshID?: string,
    onRefresh?: () => {},
    onToolBarRefresh?: () => {},
    noRecordsSelectedText?: string,
    addCustomFilterOptions?: (storedData?: any, filteredRows?: any[]) => {},
    customFilter?: (row: any, storedData?: any, rowIndex?: number, searchValLowerCase?: string, origin?: number) => boolean,
    onFocusOut?: (displayValue?: string, storedData?: any) => null,
    isSelectedKey?: string,
    customFilterCSS?: string,
    onSortEvent?: () => void,
    onSAYTTableDisplayEvent?: (saytTableObj: object, saytInputObj: object) => {},
    divSAYTWindowCSS?: string,
    onBeforeSAYTTableDisplayEvent?: (filteredRows: any[], storedData?: any) => null,
    onClearButtonClick?: (storedData?: any) => null,
    allowFreeTextInput?: boolean,
    addCustomFreeTextRow?: (displayValue?: string) => {},
    isFreeTextKey?: string,
    hiddenSelectedKey?: string,
    hiddenSelectedKeyID?: string,
    storedData?: any,
    dataKey?: string,
    title?: (storedData?: any) => string,
    name?: string,
    noneSelectedText?: string,
    hiddenSelectedKeyName?: string,
    onFocusOutEvent?: (clickedObject: any, bTab: boolean, bEscape: boolean) => boolean,
    onKeySelectionPressEvent?: (row: any, rowIndex: number, keyPressed: string, bShift: boolean, bCTRL: boolean) => null,
    hiddenTotalCountID?: string,
    overrideRowID? : (row: any, rowIndex: number, overallIndex: number) => string,
    overrideRowName? : (row: any, rowIndex: number, overallIndex: number) => string,
    reselectOnReopen: boolean,
    overrideTableEntriesText?: string,
}

interface ReactSearchAsYouTypeState {
    showTable: boolean,
    enableKeyUpSelection: boolean,
    searchValue: string,
    highlightSelectedRow: number,
    toolBarPageNumber: number,
    toolBarPageNumberTyped: number,
    storedData: any, // Row used to store the selection
    rows: any[], // All Rows to display in the SAYT List
    headers: any[],
    filteredRows: any[], // Displayed SAYT Table Rows
    disabled: boolean
}

export class ReactSearchAsYouType extends React.Component<ReactSearchAsYouTypeData> {
    useHighlightSelectedRow: boolean;
    inputRef: RefObject<any>;
    hiddenSelectedKeyRef: RefObject<any>;
    useRowDataStorage: boolean;
    popupElement: HTMLDivElement;
    popupRef: RefObject<any>;
    popUpTableObj: object;

    constructor(props: ReactSearchAsYouTypeData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.filterTable = this.filterTable.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSelectCellClick = this.onSelectCellClick.bind(this);
        this.toolBarPageLeft = this.toolBarPageLeft.bind(this);
        this.toolBarPageRight = this.toolBarPageRight.bind(this);
        this.onClearBtnClick = this.onClearBtnClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.sortUpdate = this.sortUpdate.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onHiddenKeyChange = this.onHiddenKeyChange.bind(this);
        this.onSAYTTableDisplayEvent = this.onSAYTTableDisplayEvent.bind(this);
        this.onCloseWindowClick = this.onCloseWindowClick.bind(this);
        this.highlightRow = this.highlightRow.bind(this);

        this.inputRef = React.createRef();
        this.hiddenSelectedKeyRef = React.createRef();
        this.popupRef = React.createRef();
        this.popUpTableObj = null;
        this.popupElement = null;

        this.useHighlightSelectedRow = props.highlightSelectedRow >= 0;
        this.useRowDataStorage = (null != props.dataKey && null != props.hiddenSelectedKey && null != props.storedData);

        (this.state as ReactSearchAsYouTypeState) = {
            showTable: false,
            enableKeyUpSelection: true,
            searchValue: '',
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
            storedData: props.storedData,
            rows: props.rows,
            headers: props.headers,
            filteredRows: this.filterTable('', props.rows, props.storedData, 1),
            disabled: props.disabled
        };
    }

    componentDidMount() {
        if(this.props.selectColumns.length > 0) {
            let searchVal = '';
            this.setState(() => {

                let displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
                if (this.useRowDataStorage) {
                    const index = this.indexOfKey((this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey]);
                    if (index > -1) {
                        if (displayKey.length > 0) {
                            searchVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey];

                        }
                    } else {
                        const index = this.indexOfSelected();
                        if (index > -1) {
                            if (displayKey.length > 0) {
                                searchVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey];
                            }
                        }
                    }
                    this.updateHiddenSelectedKey();

                    return {
                        searchValue: searchVal,
                        storedData: (this.state as ReactSearchAsYouTypeState).storedData,
                        rows: (this.state as ReactSearchAsYouTypeState).rows,
                        filteredRows: this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData, 2)
                    }
                }
            });
        }
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactSearchAsYouTypeData) {
        let searchVal = '';
        this.setState(() => {

            let displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
            if(displayKey.length > 0) {
                if (this.useRowDataStorage) {
                    const index = this.indexOfKey(props.rows, props.storedData[this.props.dataKey]);
                    if (index > -1) {
                        searchVal = props.rows[index][displayKey];
                    }
                } else {
                    // Get the currently selected value so we can update the State with the correct display
                    const index = this.indexOfSelected();
                    if (index > -1) {
                        searchVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey];
                    }
                }
            }

            return {
                disabled: props.disabled,
                storedData: props.storedData,
                rows: props.rows,
                searchValue: searchVal,
            }
        }, () => {this.updateHiddenSelectedKey();});
    }

    // User changed something in the SAYT Text field
    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        // If we allow Free Text then clear the selection when user types
        if(this.props.allowFreeTextInput) {
            this.clearSelection();
        }

        const searchString = event.target.value;
        const filteredRows = this.filterTable(searchString, (this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData, 3);

        this.setState({
            searchValue: searchString,
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            filteredRows: filteredRows,
            headers: (this.state as ReactSearchAsYouTypeState).headers,
            highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }, () => {this.updateHiddenSelectedKey();});
    }

    // Filter using the Search String
    searchCell(header: any, row: any, searchVal: string, searchValLowerCase: string) {
        let searchKey = (null != header.displayKey) ? header.displayKey : '';
        if(null != header.hiddenSearchKey) {
            searchKey = header.hiddenSearchKey;
        }

        // Some columns can be excluded from the search (by default all columns are searched on)
        if(null != header.disableSearch) {
            return false
        } else if(null != header.customSearch) {
            return header.customSearch(row, searchValLowerCase, searchVal);
        } else if(searchKey.length > 0 && row[searchKey]) {
            if(typeof row[searchKey] == "string") {
                if(null != header.searchOption) {
                    if(header.searchOption.toLowerCase().localeCompare("startswith") == 0) {
                        return row[searchKey].toLowerCase().startsWith(searchValLowerCase);
                    } else if(header.searchOption.toLowerCase().localeCompare("endswith") == 0) {
                        return row[searchKey].toLowerCase().endsWith(searchValLowerCase);
                    } else {
                        return row[searchKey].toLowerCase().includes(searchValLowerCase);
                    }
                } else {
                    return row[searchKey].toLowerCase().includes(searchValLowerCase);
                }
            } else if(typeof row[searchKey] == "number") {
                if(null != header.searchOption) {
                    if(header.searchOption.toLowerCase().localeCompare("startswith") == 0) {
                        return row[searchKey].toString().startsWith(searchValLowerCase);
                    } else if(header.searchOption.toLowerCase().localeCompare("endswith") == 0) {
                        return row[searchKey].toString().endsWith(searchValLowerCase);
                    } else {
                        return row[searchKey].toString().includes(searchValLowerCase);
                    }
                } else {
                    return row[searchKey].toString().includes(searchValLowerCase);
                }
            } else if(null != row[searchKey].props) {
                if(null != row[searchKey].props.value) {
                    if(null != header.searchOption) {
                        if(header.searchOption.toLowerCase().localCompare("startswith") == 0) {
                            return row[searchKey].props.value.toLowerCase().startsWith(searchValLowerCase);
                        } else if(header.searchOption.toLowerCase().localCompare("endswith")) {
                            return row[searchKey].props.value.toLowerCase().endsWith(searchValLowerCase);
                        } else {
                            return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                        }
                    } else {
                        return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                    }
                }
            }
        }
        return false;
    }

    searchRow(row: any, searchVal: string, searchValLowerCase: string, storedData: any, rowIndex: number, origin: number) {
        let skipCustomFilter = true;

        // Filter using the customFilter in addition to the SAYT
        if(null != this.props.customFilter) {
            skipCustomFilter = this.props.customFilter(row, storedData, rowIndex, searchValLowerCase, origin);
        }

        // Filter using the SAYT
        return skipCustomFilter && ((searchValLowerCase.length > 0) ? this.props.headers.map((header, cellIndex) => this.searchCell(header, row, searchVal, searchValLowerCase)).includes(true) : true);
    }

    filterTable(searchVal: string, rows: any[], storedData: any, origin: number) {
        const searchValLowerCase = (searchVal.length > 0) ? searchVal.toLowerCase() : '';
        return rows.filter((row, rowIndex) => this.searchRow(row, searchVal, searchValLowerCase.trim(), storedData, rowIndex, origin));
    }

    onClick() {
        this.inputRef.current.focus();

        if(!(this.state as ReactSearchAsYouTypeState).showTable) {
            this.onFocusIn();
        }

        const filteredRows = this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData, 4);

        if(!(this.state as ReactSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
            this.props.onBeforeSAYTTableDisplayEvent(filteredRows, (this.state as ReactSearchAsYouTypeState).storedData)
        }

        if(this.props.reselectOnReopen) {
            this.setState({
                showTable: true,
                enableKeyUpSelection: true,
                searchValue: '',
                filteredRows: filteredRows,
            });
        } else {
            this.setState({
                showTable: true,
                enableKeyUpSelection: true,
                searchValue: '',
                filteredRows: filteredRows,
                highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1,
            });
        }

        // Add a mousedown event to trigger once we click away from the SAYT
        const inputElement = $(this.inputRef.current);
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {

            const popupTableObject = (null != this.popUpTableObj) ? $(this.popUpTableObj) : $(this.popupRef.current);
            if((inputElement.closest('div').find($(event2.target)).length < 1) &&
                (popupTableObject.closest('div').find($(event2.target)).length < 1))
            {
                let bFocusOut = true;
                if(null != this.props.onFocusOutEvent) {
                    bFocusOut = this.props.onFocusOutEvent($(event2.target), false, false);
                }
                if(bFocusOut) {
                    this.onFocusOut();
                }
            }
        });
    }

    onFocusIn() {
        const inputElement = $(this.inputRef.current);
        inputElement[0].select();

        if(null == this.popupElement) {
            this.popupElement = document.createElement("div");
            this.popupElement.id = this.props.id + "_popUpWindow";
            this.popupElement.className = "positionAbsolute";
            this.popupElement.appendChild(this.popupRef.current);
            document.body.appendChild(this.popupElement);
        }

        // Add a mousedown event to trigger once we click away from the SAYT
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            const popUpTableObject = (null != this.popUpTableObj) ? $(this.popUpTableObj) : $(this.popupRef.current);

            if((inputElement.closest('div').find($(event2.target)).length < 1) &&
                (popUpTableObject.closest('div').find($(event2.target)).length < 1))
            {
                let bFocusOut = true;
                if(null != this.props.onFocusOutEvent) {
                    bFocusOut = this.props.onFocusOutEvent($(event2.target), false, false);
                }
                if(bFocusOut) {
                    this.onFocusOut();
                }
            }
        });
    }

    onFocusOut() {

        // Remove mousedown event listener that was added when we displayed the SAYT Search Table
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).off(clickEvent);

        $(this.popupElement).remove();
        this.popupElement = null;

        // Get the Json Object for the displayKey out of the header (which header to use is determined by the saytSelectDisplayColumn value)
        let displayKey = '';
        if(this.props.saytSelectDisplayColumn >= 0 && this.props.saytSelectDisplayColumn < this.props.headers.length && this.props.headers[this.props.saytSelectDisplayColumn]) {
            displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
        }

        // Get the new value to display
        let displayVal = (this.state as ReactSearchAsYouTypeState).searchValue;

        if(this.useRowDataStorage) {
            if(displayKey.length > 0) {
                const index = this.indexOfKey((this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey]);
                if (index > -1) {
                    displayVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey];
                } else {
                    if (this.props.allowFreeTextInput) {
                        const indexFreeText = this.indexOfFreeText(displayVal);
                        if (indexFreeText > -1) {
                            (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = (this.state as ReactSearchAsYouTypeState).rows[indexFreeText][this.props.hiddenSelectedKey];
                            if ((this.state as ReactSearchAsYouTypeState).rows[indexFreeText][this.props.isFreeTextKey]) {
                                (this.state as ReactSearchAsYouTypeState).rows[indexFreeText][displayKey] = displayVal; // Update the free text previously added (aka fix uppercase characters user forgot to include)
                            } else {
                                displayVal = (this.state as ReactSearchAsYouTypeState).rows[indexFreeText][displayKey]; // Update to exact text (aka add uppercase characters user didn't bother to type)
                            }
                        } else {
                            (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = ""; // There's no key to store
                            // If typed text does not exist add it to the list
                            if(null != this.props.addCustomFreeTextRow) {
                                const rowToAdd: any = this.props.addCustomFreeTextRow(displayVal);
                                if(null !== rowToAdd) {
                                    (this.state as ReactSearchAsYouTypeState).rows.push(rowToAdd);

                                    if(this.useRowDataStorage) {
                                        if(null != rowToAdd[this.props.hiddenSelectedKey]) {
                                            (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = rowToAdd[this.props.hiddenSelectedKey];
                                        }
                                    } else {
                                        // Mark the row added as selected and mark all other rows as unselected
                                        for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                                            (this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = (this.state as ReactSearchAsYouTypeState).rows[i] == rowToAdd;
                                        }
                                    }

                                }
                            } else {
                                const jsonData: any = {};
                                jsonData[this.props.isFreeTextKey] = true;
                                jsonData[displayKey] = displayVal;
                                (this.state as ReactSearchAsYouTypeState).rows.push(jsonData);
                            }
                        }
                        this.updateHiddenSelectedKey();
                    } else {
                        displayVal = "";
                    }
                }
            }
        } else {
            let bSelectionFound = false;
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                // Find the first value marked as selected
                if((this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey]) {
                    if(displayKey.length > 0 && this.props.saytSelectDisplayColumn >= 0 && this.props.saytSelectDisplayColumn < this.props.headers.length) {
                        displayVal = (this.state as ReactSearchAsYouTypeState).rows[i][displayKey];
                    } else {
                        console.log("ERROR: saytSelectDisplayColumn is OUT OR RANGE");
                    }

                    bSelectionFound = true;
                    break; // Stop searching (there should be only one value selected on a SAYT)
                }
            }

            if(!bSelectionFound && displayVal.length > 0) {
                if (this.props.allowFreeTextInput) {
                    // Check if typed in value already exists in the list and if so select it
                    const index = this.indexOfFreeText(displayVal);
                    if(index > -1) {
                        (this.state as ReactSearchAsYouTypeState).rows[index][this.props.isSelectedKey] = true;
                        if(displayKey.length > 0) {
                            if((this.state as ReactSearchAsYouTypeState).rows[index][this.props.isFreeTextKey]) {
                                (this.state as ReactSearchAsYouTypeState).rows[index][displayKey] = displayVal; // Update the free text previously added (aka fix uppercase characters user forgot to include)
                            } else {
                                displayVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey]; // Update to exact text (aka add uppercase characters user didn't bother to type)
                            }
                        }
                    } else {
                        // If typed text does not exist add it to the list
                        if(null != this.props.addCustomFreeTextRow) {
                            const rowToAdd: any = this.props.addCustomFreeTextRow(displayVal);
                            if(null !== rowToAdd) {
                                (this.state as ReactSearchAsYouTypeState).rows.push(rowToAdd);

                                if(this.useRowDataStorage) {
                                    if(null != rowToAdd[this.props.hiddenSelectedKey]) {
                                        (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = rowToAdd[this.props.hiddenSelectedKey];
                                    }
                                } else {
                                    // Mark the row added as selected and mark all other rows as unselected
                                    for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                                        (this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = (this.state as ReactSearchAsYouTypeState).rows[i] == rowToAdd;
                                    }
                                }
                            }
                        } else {
                            const jsonData: any = {};
                            jsonData[this.props.isSelectedKey] = true;
                            jsonData[this.props.isFreeTextKey] = true;
                            jsonData[displayKey] = displayVal;
                            (this.state as ReactSearchAsYouTypeState).rows.push(jsonData);
                        }
                    }
                    this.updateHiddenSelectedKey();
                } else {
                    displayVal = '';
                }
            }
        }

        // Update the state
        this.setState({
            storedData: (this.state as ReactSearchAsYouTypeState).storedData,
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            showTable: false,
            enableKeyUpSelection: true,
            searchValue: displayVal
        }, () => {
            // Call focus out function if one exists
            if(this.props.onFocusOut) {
                this.props.onFocusOut(displayVal, (this.state as ReactSearchAsYouTypeState).storedData);
            }
        });
    }

    // Get the next row to highlight for the highlightSelectedRow
    getNextRow(rowIndex: number, keyUp: boolean, totalRows: number) {
        let nextRow = rowIndex;
        if(keyUp) {
            if(nextRow > 0) {
                nextRow--;
            }
        } else {
            if(nextRow < (totalRows - 1)) {
                nextRow++;
            }
        }
        return nextRow;
    }

    // Shift the page left or back to 1
    toolBarPageLeft() {
        this.setState((prev: ReactSearchAsYouTypeState) => ({
            toolBarPageNumber: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            toolBarPageNumberTyped: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((prev.toolBarPageNumber > 1) ? 0 : (this.state as ReactSearchAsYouTypeState).highlightSelectedRow): -1),
        }));
    }

    // Shift the page right or to the end
    toolBarPageRight() {
        const totalPages = Math.ceil((this.state as ReactSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactSearchAsYouTypeState).toolBarPageNumber),
            toolBarPageNumberTyped: (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactSearchAsYouTypeState).toolBarPageNumber),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? 0 : (this.state as ReactSearchAsYouTypeState).highlightSelectedRow): -1),
        }));
    }

    highlightRow(event: any) {
        const rowIndex = +$(event.currentTarget).val();// Adjust the page number if needed
        if(rowIndex > -1 && rowIndex < (this.state as ReactSearchAsYouTypeState).rows.length) {
            const selectedIndex = this.getHighlightIndex(rowIndex);
            const totalPages = Math.ceil((this.state as ReactSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);

            let goToPage = Math.ceil((rowIndex + 1)/this.props.toolBarNumToDisplay);
            if(goToPage < 1) {
                goToPage = 1;
            } else if(goToPage > totalPages) {
                goToPage = totalPages;
            }

            this.setState((prev: ReactSearchAsYouTypeState) => ({
                toolBarPageNumber: goToPage,
                toolBarPageNumberTyped: goToPage,
                highlightSelectedRow: selectedIndex,
            }));
        }
    }

    onCloseWindowClick(event: any) {
        this.onFocusOut();
    }

    onKeyUp(event: any) {
        const keyEnter = event.key == "Enter";
        if((this.state as ReactSearchAsYouTypeState).enableKeyUpSelection) {
            if(keyEnter) {
                // Select the highlight selected row on enter
                if(this.useHighlightSelectedRow) {
                    const selectIndex = this.getIndexFromHighlight();
                    if(selectIndex >= 0 && selectIndex < (this.state as ReactSearchAsYouTypeState).filteredRows.length) {
                        this.onSelectCellClick((this.state as ReactSearchAsYouTypeState).filteredRows[selectIndex]);
                    }
                }
            }
        }

        this.setState({
            enableKeyUpSelection: true,
        });
    }

    // User typed something in the SAYT Text field
    onKeyPress(event: any, ignoreOverride?: boolean) {
        const keyUp = event.key == "ArrowUp";
        const keyDown = event.key == "ArrowDown";
        const keyLeft = event.key == "ArrowLeft";
        const keyRight = event.key == "ArrowRight";
        const keyTab = event.key == "Tab";
        const keyEsc = event.key == "Escape";
        const keyEnter = event.key == "Enter";
        const keyDelete = event.key == "Delete";
        const keyBackspace = event.key == "Backspace";
        let keyPressed = false;

        // If the table is not displayed, determine if the key pressed should display it
        // Special keys like "Shift" should not display the table
        if((event.key.length == 1 || (keyUp || keyDown || keyLeft || keyRight || keyEnter || keyDelete || keyBackspace)) && !(this.state as ReactSearchAsYouTypeState).showTable) {

            const filteredRows = this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData, 5);

            if(!(this.state as ReactSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
                this.props.onBeforeSAYTTableDisplayEvent(filteredRows, (this.state as ReactSearchAsYouTypeState).storedData)
            }

            this.onFocusIn();

            if(this.props.reselectOnReopen) {
                this.setState({
                    showTable: true,
                    enableKeyUpSelection: false, // Prevent enter key from selecting anything while we are still trying to display the pop-up
                    searchValue: '',
                    filteredRows: filteredRows,
                });
            } else {
                this.setState({
                    showTable: true,
                    enableKeyUpSelection: false, // Prevent enter key from selecting anything while we are still trying to display the pop-up
                    searchValue: '',
                    filteredRows: filteredRows,
                    highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                    toolBarPageNumber: 1,
                    toolBarPageNumberTyped: 1,
                });
            }
        } else if (null == ignoreOverride && !ignoreOverride && null != this.props.onKeySelectionPressEvent && (keyUp || keyDown || keyLeft || keyRight || keyEnter)) {
            const selectIndex = (this.state as ReactSearchAsYouTypeState).highlightSelectedRow;
            const selectRow = (selectIndex > -1 && selectIndex < (this.state as ReactSearchAsYouTypeState).filteredRows.length) ?  (this.state as ReactSearchAsYouTypeState).filteredRows[(this.state as ReactSearchAsYouTypeState).highlightSelectedRow] : null;
            this.props.onKeySelectionPressEvent(selectRow, selectIndex, event.key, event.shiftKey, event.ctrlKey);
            keyPressed = true;
        } else if (this.useHighlightSelectedRow && (keyUp || keyDown)) {

            // Adjust the highlight row selected
            let updateHighlightPosition = true;
            let newSelectedRow = this.getNextRow((this.state as ReactSearchAsYouTypeState).highlightSelectedRow, keyUp, (this.state as ReactSearchAsYouTypeState).filteredRows.length);

            // Adjust the page number if needed
            let pageNumber = (this.state as ReactSearchAsYouTypeState).toolBarPageNumber;
            if(keyUp && pageNumber > 1 && (this.state as ReactSearchAsYouTypeState).highlightSelectedRow == 0) {
                newSelectedRow = this.props.toolBarNumToDisplay - 1;
                pageNumber--;
            } else if(keyDown) {
                if((newSelectedRow + ((pageNumber - 1) * this.props.toolBarNumToDisplay)) <= ((this.state as ReactSearchAsYouTypeState).filteredRows.length - 1)) {
                    if(newSelectedRow >= this.props.toolBarNumToDisplay) {
                        const totalPages = Math.ceil((this.state as ReactSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
                        if (pageNumber < totalPages) {
                            newSelectedRow = 0;
                            pageNumber++;
                        } else {
                            updateHighlightPosition = false;
                        }
                    }
                } else {
                    updateHighlightPosition = false;
                }
            }

            keyPressed = true;

            // If the highlight position should be adjusted update the state
            if(updateHighlightPosition) {
                this.setState((prev: ReactSearchAsYouTypeState) => ({
                    highlightSelectedRow: newSelectedRow,
                    toolBarPageNumber: pageNumber,
                    toolBarPageNumberTyped: pageNumber,
                }));
            }
        } else if (keyLeft || keyRight) {
            // Update the page number using the left and right keyboard arrow keys
            if (keyLeft) {
                this.toolBarPageLeft();
                keyPressed = true;
            } else if (keyRight) {
                this.toolBarPageRight();
                keyPressed = true;
            }
        } else if(keyTab || keyEsc) {
            let bFocusOut = true;
            if(null != this.props.onFocusOutEvent) {
                bFocusOut = this.props.onFocusOutEvent(null, keyTab, keyEsc);
            }
            if(bFocusOut) {
                this.onFocusOut();
            }
        }

        if (keyPressed || keyEnter) {
            event.preventDefault();
        }
    }

    getIndexFromHighlight() {
        return (this.state as ReactSearchAsYouTypeState).highlightSelectedRow + (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
    }

    getHighlightIndex(indexToHighlight: number) {
        return indexToHighlight % this.props.toolBarNumToDisplay;
    }

    // Get the index for the row in the rows array
    indexOfRow(row: any) {
        for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
            if(row == (this.state as ReactSearchAsYouTypeState).rows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    indexOfHiddenSelectedKey(key: string) {
        if(null != this.props.hiddenSelectedKey) {
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                if(key == (this.state as ReactSearchAsYouTypeState).rows[i][this.props.hiddenSelectedKey]) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Select the row
    onSelectCellClick(row: any) {
        const rowIndex = this.indexOfRow(row);
        if(!(this.state as ReactSearchAsYouTypeState).disabled && rowIndex >= 0) {

            if(this.useRowDataStorage) {
                (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = (this.state as ReactSearchAsYouTypeState).rows[rowIndex][this.props.hiddenSelectedKey];
            } else {
                // Mark the row passed in as selected and mark all other rows as unselected
                for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                    (this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = (i == rowIndex);
                }
            }

            // Check if we should close the table on select
            if(this.props.hideSearchOnSelect) {
                this.setState({
                    storedData: (this.state as ReactSearchAsYouTypeState).storedData,
                    highlightSelectedRow: (((this.state as ReactSearchAsYouTypeState).highlightSelectedRow > -1) ? 0 : -1),
                    toolBarPageNumber: 1,
                    toolBarPageNumberTyped: 1,
                }, () => {
                    // Call the onSAYTClickEvent function if it exists
                    if(null != this.props.onSAYTClickEvent) {
                        this.props.onSAYTClickEvent(row, (this.state as ReactSearchAsYouTypeState).storedData);
                    }
                });

                this.onFocusOut();
            } else {
                this.setState({
                    storedData: (this.state as ReactSearchAsYouTypeState).storedData,
                }, () => {
                    // Call the onSAYTClickEvent function if it exists
                    if(null != this.props.onSAYTClickEvent) {
                        this.props.onSAYTClickEvent(row, (this.state as ReactSearchAsYouTypeState).storedData);
                    }
                });
            }

            this.updateHiddenSelectedKey();
        }
    }

    updateHiddenSelectedKey() {
        if(null != this.props.hiddenSelectedKey) {
            const newIndex = (this.useRowDataStorage) ? this.indexOfKey((this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey]) : this.indexOfSelected();
            if(newIndex >= 0) {
                $(this.hiddenSelectedKeyRef.current).val((this.state as ReactSearchAsYouTypeState).rows[newIndex][this.props.hiddenSelectedKey]);
            } else {
                $(this.hiddenSelectedKeyRef.current).val("");
            }
        }
    }

    // Build the SAYT label
    buildLabel() {
        return <label style={this.props.labelStyle} className={(null != this.props.labelCSS) ? this.props.labelCSS(this.indexOfSelected()) : ""}>
            {this.props.label}
        </label>
    }

    // Get the index of the first selected row (should only be one row selected)
    indexOfSelected() {
        if(this.useRowDataStorage) {
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                if((this.state as ReactSearchAsYouTypeState).rows[i][this.props.hiddenSelectedKey] == (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey]) {
                    return i;
                }
            }
        } else {
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                if((this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey]) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Get the index of the first selected row (should only be one row selected)
    indexOfSelectedRow(rows: any[]) {
        if(this.useRowDataStorage) {
            for(let i = 0; i < rows.length; i++) {
                if(rows[i][this.props.hiddenSelectedKey] == (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey]) {
                    return i;
                }
            }
        } else {
            for(let i = 0; i < rows.length; i++) {
                if(rows[i][this.props.isSelectedKey]) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Get the index of the first row matching the text value
    indexOfFreeText(freeText: string) {
        const displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
        if(displayKey.length > 0) {
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                if((this.state as ReactSearchAsYouTypeState).rows[i][displayKey].toLowerCase() === freeText.toLowerCase()) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Get the index of the key
    indexOfKey(rows: any[], key: string) {
        const selectedKey = (null != this.props.hiddenSelectedKey) ? this.props.hiddenSelectedKey : '';
        if(selectedKey.length > 0) {
            for(let i = 0; i < rows.length; i++) {
                if(rows[i][selectedKey] === key) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Clear all selected SAYT rows
    clearSelection() {
        if(this.useRowDataStorage) {
            (this.state as ReactSearchAsYouTypeState).storedData[this.props.dataKey] = "";
        } else {
            let index = this.indexOfSelected();
            while(index >= 0) {
                (this.state as ReactSearchAsYouTypeState).rows[index][this.props.isSelectedKey] = false;
                index = this.indexOfSelected();
            }
        }
    }

    onClearBtnClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.clearSelection();

        // Update the state and when finished updating call the onFocusOut event
        this.setState({
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            searchValue: "",
            highlightSelectedRow: (((this.state as ReactSearchAsYouTypeState).highlightSelectedRow > -1) ? 0 : -1),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }, () => {
            this.onFocusOut();

            if(null != this.props.onClearButtonClick) {
                this.props.onClearButtonClick((this.state as ReactSearchAsYouTypeState).storedData);
            }

            this.updateHiddenSelectedKey();
        });
    }

    onDisableClick(event: any) {
        this.setState({
            disabled: !(this.state as ReactSearchAsYouTypeState).disabled
        });
    }

    sortUpdate(props: ReactTableState, onLoad: boolean) {
        if(onLoad && this.props.reselectOnReopen) {
            const filteredRows = this.filterTable((this.state as ReactSearchAsYouTypeState).searchValue, props.rows, props.storedData, 6);
            const rowIndex = this.indexOfSelectedRow(filteredRows);

            let goToPage = 1;
            let selectedIndex = (this.useHighlightSelectedRow) ? 0 : -1;
            if(rowIndex > -1) {
                if(this.useHighlightSelectedRow) {
                    selectedIndex = this.getHighlightIndex(rowIndex);
                }

                const totalPages = Math.ceil(filteredRows.length/this.props.toolBarNumToDisplay);
                goToPage = Math.ceil((rowIndex + 1)/this.props.toolBarNumToDisplay);
                if(goToPage < 1) {
                    goToPage = 1;
                } else if(goToPage > totalPages) {
                    goToPage = totalPages;
                }
            }

            this.setState(() => ({
                filteredRows: filteredRows,
                highlightSelectedRow: selectedIndex,
                toolBarPageNumber: goToPage,
                toolBarPageNumberTyped: goToPage,
            }));
        } else {
            this.setState(() => ({
                filteredRows: this.filterTable((this.state as ReactSearchAsYouTypeState).searchValue, props.rows, props.storedData, 6),
                highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1,
            }));
        }
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState((prev: ReactSearchAsYouTypeState) => ({
            filteredRows: this.filterTable(prev.searchValue, (this.state as ReactSearchAsYouTypeState).rows, (this.state as ReactSearchAsYouTypeState).storedData, 7),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }));
    }

    onHiddenKeyChange(event: any) {
        if(!(this.state as ReactSearchAsYouTypeState).disabled) {
            const rowIndex = this.indexOfHiddenSelectedKey($(event.currentTarget).val() + "");
            if(rowIndex > -1) {
                this.onSelectCellClick((this.state as ReactSearchAsYouTypeState).rows[rowIndex]);
            } else {
                this.clearSelection();

                // Update the state and when finished updating call the onFocusOut event
                this.setState({
                    rows: (this.state as ReactSearchAsYouTypeState).rows,
                    searchValue: ""
                }, () => {
                    this.onFocusOut();

                    if(null != this.props.onClearButtonClick) {
                        this.props.onClearButtonClick((this.state as ReactSearchAsYouTypeState).storedData);
                    }

                    this.updateHiddenSelectedKey();
                });
            }
        }
    }

    onSAYTTableDisplayEvent(saytTableObj: object) {
        if(null != this.props.onSAYTTableDisplayEvent) {
            if($(this.popupElement) && this.inputRef.current) {
                $(this.popupElement).height($(saytTableObj).height());
                $(this.popupElement).width($(saytTableObj).width());
                this.props.onSAYTTableDisplayEvent($(this.popupElement), $(this.inputRef.current));
            }
        }

        this.popUpTableObj = saytTableObj;
    }

    buildClearButton() {
        return <button id={this.props.id + "_clear"} type="button" className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.clearButtonTabIndex} title="Clear" onClick={this.onClearBtnClick} disabled={(this.state as ReactSearchAsYouTypeState).disabled} >
            <div>
                <span className="ui-button-icon ui-icon ui-icon-circle-close"></span>
                <span className="ui-button-icon-space"></span>
                Clear
            </div>
        </button>;
    }

    buildSearchButton() {
        return <button id={this.props.id + "_search"} className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.searchButtonTabIndex} type="button" title="Search" onClick={this.onClick} disabled={(this.state as ReactSearchAsYouTypeState).disabled}>
            <span className="ui-button-icon ui-icon ui-icon-search"></span><span className="ui-button-icon-space"></span>
            Search
        </button>;
    }

    buildSAYTButtons() {
        const clearButton = (this.props.showClearButton) ? this.buildClearButton() : null;
        const searchButton = (this.props.showSearchButton) ? this.buildSearchButton() : null;

        return <td className='nowrap' style={{verticalAlign: "middle", paddingLeft: "4px"}}>
            {(this.props.showSearchButtonAfterClearButton) ? clearButton : searchButton}
            <span style={{paddingLeft: (null != clearButton && null != searchButton) ? '4px' : '0px'}}></span>
            {(this.props.showSearchButtonAfterClearButton) ? searchButton : clearButton}
        </td>
    }

    render() {
        return <div id={this.props.id + '_shellDiv'} className={this.props.css} style={this.props.style}>
            <tr>
                {<table className="categoryAllHide"><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        onChange={this.onDisableClick}
                        checked={(this.state as ReactSearchAsYouTypeState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                </tr><tr>
                    <td><input
                        ref={this.hiddenSelectedKeyRef}
                        id={(null != this.props.hiddenSelectedKeyID) ? this.props.hiddenSelectedKeyID : this.props.id + "_hiddenSelectedKey"}
                        name={(null != this.props.hiddenSelectedKeyName) ? this.props.hiddenSelectedKeyName : this.props.id + "_hiddenSelectedKey"}
                        onClick={this.onHiddenKeyChange} // Could not get JQuery to update React onChange easily, but OnClick works!
                    /></td>
                    <td>
                        HIDDEN SELECTED KEY
                    </td>
                </tr>
                <tr>
                    <td><input id={this.props.id + "_highlight"} onClick={this.highlightRow} value={this.getIndexFromHighlight()} autoComplete="off" ></input></td>
                    <td>
                        HIDDEN HIGHLIGHT INDEX
                    </td>
                    <td><input id={this.props.hiddenTotalCountID} value={(this.state as ReactSearchAsYouTypeState).filteredRows.length} autoComplete="off"/>
                    </td>
                    <td>
                        HIDDEN TOTAL COUNT
                    </td>
                    <td><button id={this.props.id + "_up"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyup', { key: 'ArrowUp'}), true)}}>HIDDEN UP BUTTON</button></td>
                    <td><button id={this.props.id + "_down"} onClick={event => {this.onKeyPress(new KeyboardEvent('keydown', { key: 'ArrowDown'}),true)}}>HIDDEN DOWN BUTTON</button></td>
                    <td><button id={this.props.id + "_left"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyleft', { key: 'ArrowLeft'}), true)}}>HIDDEN LEFT BUTTON</button></td>
                    <td><button id={this.props.id + "_right"} onClick={event => {this.onKeyPress(new KeyboardEvent('keyright', { key: 'ArrowRight'}), true)}}>HIDDEN RIGHT BUTTON</button></td>
                </tr>
                </table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                {getReactButton({id: this.props.id + "_closePopupWindow", css: "categoryAllHide", onClick: this.onCloseWindowClick, text: "HIDDEN CLOSE POPUP BUTTON"})}
                <td style={{verticalAlign: "middle"}}>
                    {(this.props.label.length > 0) ? this.buildLabel() : null}
                </td>
                <td style={{verticalAlign: "middle"}}>
                    <table >
                        <tr>
                            <td>
                                <input
                                    ref={this.inputRef}
                                    id={this.props.id}
                                    name={this.props.name}
                                    type="text"
                                    value={((this.state as ReactSearchAsYouTypeState).searchValue.length > 0 || (this.state as ReactSearchAsYouTypeState).showTable) ? (this.state as ReactSearchAsYouTypeState).searchValue : this.props.noneSelectedText}
                                    style={this.props.textStyle}
                                    className={this.props.textCSS}
                                    tabIndex={this.props.tabIndex}
                                    onClick={this.onClick}
                                    onChange={this.handleChange}
                                    onKeyDown={this.onKeyPress}
                                    onKeyUp={this.onKeyUp}
                                    onFocus={this.onFocusIn}
                                    disabled={(this.state as ReactSearchAsYouTypeState).disabled}
                                    autoComplete="off"
                                    title={(null != this.props.title) ? this.props.title((this.state as ReactSearchAsYouTypeState).storedData) : ""}
                                />
                            </td>
                        </tr>
                        <tr id={this.props.id + '_table_saytTableShell'}>
                            <td ref={this.popupRef} id={this.props.id + "_popUpWindowData"}>
                                {((this.state as ReactSearchAsYouTypeState).showTable) ? getReactTableLocal({
                                    id: this.props.id + '_table',
                                    highlightSelectedRow: (this.state as ReactSearchAsYouTypeState).highlightSelectedRow,
                                    toolBarPageNumber: (this.state as ReactSearchAsYouTypeState).toolBarPageNumber,
                                    toolBarPageNumberTyped: (this.state as ReactSearchAsYouTypeState).toolBarPageNumberTyped,
                                    selectColumns: this.props.selectColumns,
                                    saytSelectDisplayColumn: this.props.saytSelectDisplayColumn,
                                    headers: this.props.headers,
                                    headersCSS: this.props.headersCSS,
                                    rowsCSS: this.props.rowsCSS,
                                    rowsStyle: this.props.rowsStyle,
                                    useRowDataStorage: this.useRowDataStorage,
                                    storedData: (this.state as ReactSearchAsYouTypeState).storedData,
                                    rows: (this.state as ReactSearchAsYouTypeState).rows,
                                    filteredRows: (this.state as ReactSearchAsYouTypeState).filteredRows,
                                    showTable: (this.state as ReactSearchAsYouTypeState).showTable,
                                    isSearchAsYouType: true,
                                    style: this.props.tableStyle,
                                    toolBarNumToDisplay: this.props.toolBarNumToDisplay,
                                    toolBarDisplayHeader: this.props.toolBarDisplayHeader,
                                    toolBarDisplayFooter: this.props.toolBarDisplayFooter,
                                    toolBarDisplayCompact: true,
                                    onSelectCellClick: this.onSelectCellClick,
                                    sortUpdate: this.sortUpdate,
                                    hideSAYTOnSelect: this.props.hideSearchOnSelect,
                                    disableHeaderScrolling: this.props.disableHeaderScrolling,
                                    noRecordsSelectedText: this.props.noRecordsSelectedText,
                                    addCustomFilterOptions: this.props.addCustomFilterOptions,
                                    customFilterCSS: this.props.customFilterCSS,
                                    css: this.props.divTableContainerCSS,
                                    toolBarRefreshID: this.props.toolBarRefreshID,
                                    onToolBarRefresh: this.props.onToolBarRefresh,
                                    selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                                    isSelectedKey: this.props.isSelectedKey,
                                    hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                                    rowHasFocusCSS: this.props.rowHasFocusCSS,
                                    onSortEvent: this.props.onSortEvent,
                                    onSAYTTableDisplayEvent: this.onSAYTTableDisplayEvent,
                                    divSAYTWindowCSS: this.props.divSAYTWindowCSS,
                                    hiddenSelectedKey: this.props.hiddenSelectedKey,
                                    dataKey: this.props.dataKey,
                                    overrideRowID: this.props.overrideRowID,
                                    overrideRowName: this.props.overrideRowName,
                                    overrideTableEntriesText: this.props.overrideTableEntriesText,
                                }) : null}
                            </td>
                        </tr>
                    </table>
                </td>
                {this.buildSAYTButtons()}
            </tr>
        </div>;
    }
}
